// extracted by mini-css-extract-plugin
export var completionBody = "_lx-2";
export var completionCard = "_lx-0";
export var completionFooter = "_lx-3";
export var completionTitle = "_lx-1";